import { apiFetch } from "./client.js";

export async function listGoals(kidId: string): Promise<Goal[]> {
  return apiFetch<Goal[]>(`/api/kids/${encodeURIComponent(kidId)}/goals`);
}

export interface Goal {
  rowKey: string;
  title: string;
  targetCents: number;
  savedCents: number;
  icon: string;
  allocType: "$" | "%";
  allocValue: number;
}

export interface CreateGoalBody {
  title: string;
  targetCents: number;
  icon: string;
  allocType: "$" | "%";
  allocValue: number;
}

export type PatchGoalBody = Partial<CreateGoalBody>;

export async function createGoal(kidId: string, body: CreateGoalBody): Promise<Goal> {
  return apiFetch<Goal>(`/api/kids/${encodeURIComponent(kidId)}/goals`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function patchGoal(kidId: string, goalId: string, body: PatchGoalBody): Promise<Goal> {
  return apiFetch<Goal>(
    `/api/kids/${encodeURIComponent(kidId)}/goals/${encodeURIComponent(goalId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    },
  );
}

export async function deleteGoal(kidId: string, goalId: string): Promise<void> {
  await apiFetch<unknown>(
    `/api/kids/${encodeURIComponent(kidId)}/goals/${encodeURIComponent(goalId)}`,
    { method: "DELETE" },
  );
}

export async function depositToGoal(
  kidId: string,
  goalId: string,
  amountCents: number,
): Promise<Goal> {
  return apiFetch<Goal>(
    `/api/kids/${encodeURIComponent(kidId)}/goals/${encodeURIComponent(goalId)}/deposit`,
    {
      method: "POST",
      body: JSON.stringify({ amountCents }),
    },
    true,
  );
}
